<template>
  <BaseModal
    :id="id"
    :confirm-text="$t('Delete')"
    :on-confirm="confirmDelete"
    :heading="headingText"
    confirm-class="comet-button--danger"
  >
    <!-- If we are deleting one page, show the page name -->
    <p v-if="!isMultiDelete && pageName">
      {{ $t('Are you sure you’d like to delete %(pageName)s?', {
        pageName,
        interpolation: { escapeValue: false },
      }) }}
    </p>

    <!-- If we're deleting multiple, show a message based on draft type -->
    <p v-else-if="draft.options.type === 'board'">
      {{ $t('Are you sure you’d like to delete %(count)d page?', {
        count: options.pageIds.length,
      }) }}
    </p>
    <p v-else>
      {{ $t('Are you sure you’d like to delete %(count)d slide?', {
        count: options.pageIds.length,
      }) }}
    </p>
  </BaseModal>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { find, get } from 'lodash-es';
import BaseModal from '@/components/modals/BaseModal.vue';
import * as types from '@/lib/constants/store';
import {
  useEditorStore,
  useModalStore,
} from '@/stores';

export default {
  name: 'ConfirmDeletePage',
  components: {
    BaseModal,
  },
  props: {
    id: {
      type: String, // used for opening and closing modal
      required: true,
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapState(useEditorStore, [
      'draft',
    ]),
    headingText() {
      if (this.isMultiDelete) {
        return this.draft.options.type === 'board'
          ? this.$t('Delete Pages')
          : this.$t('Delete Slides');
      }

      return this.draft.options.type === 'board'
        ? this.$t('Delete Page')
        : this.$t('Delete Slide');
    },
    isMultiDelete() {
      return this.options.pageIds.length > 1;
    },
    pageName() {
      return (get(
        find(this.draft?.pages, (page) => page.id === this.options.pageIds[0]),
        'title',
        '',
      ) || '').trim();
    },
  },
  methods: {
    ...mapActions(useModalStore, [
      types.CLOSE_MODAL,
    ]),
    ...mapActions(useEditorStore, [
      types.DELETE_PAGE,
    ]),
    confirmDelete() {
      this.options.pageIds.forEach((pageId) => {
        this[types.DELETE_PAGE](pageId);
      });

      this[types.CLOSE_MODAL]({ id: this.id });
    },
  },
};
</script>
